<div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
</div>
<div class="modal-body">
    <table class="table table-striped expandable-rows d-none d-lg-block">
        <thead>
        <tr>
            <th class="fit">Name</th>
            <th class="fit">Status</th>
            <th>Reason</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let response of responses">
            <td class="fit"><ng-template #description>{{response.description}}</ng-template>
                <i *ngIf="response.description" class="fas fa-info-circle" aria-hidden="true"
                    [ngbPopover]="description" popoverTitle="Description" style="margin-right:5px;"
                    triggers="mouseenter:mouseleave"></i>{{ response.firstName }}, {{ response.lastName }}</td>
            <td class="text-center">
                <span   [class.bg-success]="response.statusCode === 200" 
                        [class.bg-danger]="response.statusCode !== 200"
                        class="badge">{{response.statusCode === 200 ? successLabel : failedLabel}}</span>
            </td>    
            <td>{{response.message}}</td>
        </tr>
        </tbody>
    </table>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-info" (click)="activeModal.close()">Ok</button>
</div>